export default __webpack_public_path__ + "static/media/Clock.af33c85f.svg";